import type { ModalProps } from '@hover/blueprint';
import { Body, Button, Modal } from '@hover/blueprint';
import React from 'react';

import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

export interface DiscardModalProps extends Omit<ModalProps, 'children'> {
  onDiscard: () => void;
}

export const DiscardModal = ({ onDiscard, ...props }: DiscardModalProps) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  const { onClose } = props;

  return (
    <Modal
      footer={
        <>
          <Button onClick={onDiscard}>
            {t('customize.confirmDiscardModal.discard')}
          </Button>
          <Button onClick={onClose} variant="secondary">
            {t('customize.confirmDiscardModal.cancel')}
          </Button>
        </>
      }
      {...props}
      size="small"
    >
      <Body m={0}>{t('customize.confirmDiscardModal.body')}</Body>
    </Modal>
  );
};
